import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import {
  required,
  min,
  max,
  is,
  // eslint-disable-next-line camelcase
  is_not,
  confirmed,
  email,
  // eslint-disable-next-line camelcase
  alpha_num,
  numeric,
  integer,
  length,
  // eslint-disable-next-line camelcase
  min_value,
  // eslint-disable-next-line camelcase
  max_value,
  regex
} from 'vee-validate/dist/rules'

extend('required', required)
extend('min', min)
extend('max', max)
extend('is', is)
extend('is_not', is_not)
extend('confirmed', confirmed)
extend('email', email)
extend('alpha_num', alpha_num)
extend('numeric', numeric)
extend('integer', integer)
extend('length', length)
extend('min_value', min_value)
extend('max_value', max_value)
extend('regex', regex)
// For other customized extensions, please see the i18n.js plugin

Vue.component('ValidationObserver', ValidationObserver)
Vue.component('ValidationProvider', ValidationProvider)
